import React from 'react';

const Computer = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    fill="currentColor"
    {...props}
  >
    <path d="M10.6667 24.3335H21.3334C21.8856 24.3335 22.3334 24.7812 22.3334 25.3335C22.3334 25.8858 21.8856 26.3335 21.3334 26.3335H10.6667C10.1144 26.3335 9.66669 25.8858 9.66669 25.3335C9.66669 24.7812 10.1144 24.3335 10.6667 24.3335Z M2.66669 9.3335C2.66669 7.12436 4.45755 5.3335 6.66669 5.3335H25.3334C27.5425 5.3335 29.3334 7.12436 29.3334 9.3335V18.6668C29.3334 20.876 27.5425 22.6668 25.3334 22.6668H6.66668C4.45754 22.6668 2.66669 20.876 2.66669 18.6668V9.3335ZM6.66669 7.3335C5.56212 7.3335 4.66669 8.22893 4.66669 9.3335V18.6668C4.66669 19.7714 5.56212 20.6668 6.66668 20.6668H25.3334C26.4379 20.6668 27.3334 19.7714 27.3334 18.6668V9.3335C27.3334 8.22892 26.4379 7.3335 25.3334 7.3335H6.66669Z" />
  </svg>
);

export default Computer;
